const setTariffList = (state, tariffList) => {
  state.tariffList = tariffList;
};

export default {
  setTariffList
};



// WEBPACK FOOTER //
// ./src/store/modules/tariff/mutations.js